export const USERS_TAB = "report_users";
export const ROLES_TAB = "report_roles";
export const PRODUCTS_TAB = "reports_products";
export const DOCTORS_TAB = "reports_doctors";
export const ADD_DOCTOR_TAB = "add_doctor";
export const CUSTOMER_TAB = "reports_customers";
export const GENERATE_OTP_TAB = "generate_otp";
export const HEALTH_STATUS_TAB = "health_status";
export const RETAILER_REPORTS_TAB = "report_retailer";
export const CONFIGURATION_TAB = "configuration";
export const ADD_PRODUCT_GENERAL_TAB = "add_product_general_tab";
export const ADD_BANK_GENERAL_TAB = "add_bank_general_tab";
export const ADD_BANK_MISCELLANEOUS_TAB = "add_bank_miscellaneous_tab";
export const ADD_PRODUCT_STOCK_OR_PRICES_TAB =
  "add_product_stock_or_prices_tab";
export const ADD_PRODUCT_MISCELLANEOUS_TAB = "add_product_miscellaneous_tab";
export const BANK_TAB = "reports_bank";
export const ENTITY_TAB = "reports_family";
export const TRANSPORTATION_TAB = "reports_transportation";
export const HSN_TAB = "reports_hsn";
export const DISTRIBUTOR_TAB = "reports_Distributors";
export const ADD_DISTRIBUTOR_GENERAL_TAB = "add_distributor_general_tab";
export const ADD_DISTRIBUTOR_LICENSE_TAB = "add_distributor_license_tab";
export const ADD_DISTRIBUTOR_ACCOUNT_TAB = "add_distributor_account_tab";
export const ADD_DISTRIBUTOR_VISIT_TAB = "add_distributor_visit_tab";
export const STOCK_AUDIT_TAB = "stock_audit";
export const REPORTS_STOCK_AUDIT = "report_stock_audit";
export const REPORTS_STOCK_TRANSFER = "report_stock_transfer";
export const REPORTS_STOCK_REQUEST = "report_stock_request";
export const REPORTS_MEDICINE_WISE_STOCK_AUDIT =
  "report_medicine_wise_stock_audit";
export const REPORTS_DISCOUNT_SLAB = "report_discount_slab";
export const REPORTS_DISCOUNT_PROGRAM = "report_discount_program";
export const PROFESSION_TAB = "reports_Profession";
export const SPECIALITY_TAB = "reports_Speciality";
export const ADD_SYSTEM_TAB = "add_system";
export const REPORTS_MEDICINE_WISE_STOCK_TRANSFER =
  "report_medicine_wise_stock_transfer";
export const REPORTS_MEDICINE_WISE_STOCK_REQUEST =
  "report_medicine_wise_stock_request";
export const ADD_SERVICE_ITEM_TAB = "add_service_item";
export const MANUFACTURER_TAB = "report_manufacturers";
export const MANUFACTURER_GROUP_TAB = "report_manufacturer_group";
export const BRANCH_GROUP_TAB = "branch_group";
export const REPORTS_FREQUENCY_SLAB_TAB = "report_frequency_slab";
export const CAC_USER_TAB = "cac_users";
export const DISCOUNT_PROGRAM_TAB = "discount_program_tab";
export const DOCTOR_COMMISSION_TAB = "doctor_commission_tab";
export const REPORTS_DOCTOR_COMMISSION_PROGRAM = "report_doctor_commission_program";
export const REPORTS_MODE_CONFIG_PRICING = "report_mode_config_pricing";